const partner = {
  image: "https://via.placeholder.com/100/D1DBE3?text= ",
  name: "Emily Jørgensen",
  profession: "Author at Panoply Store",
};

const partnerList = new Array(8).fill(partner);

export default partnerList;
